'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';

var API_URL = 'https://staging-ms.vietnamworks.com/smartnavi/v2/jobs';
// const langCode = 'vi'
var LANG_ID_EN = 2;
var VNW_BASE_URL = 'https://staging.vietnamworks.com';
var UTM = {
    utm_source: 'vnw_homepage',
    utm_medium: 'TopJobReco',
    utm_campaign: 'TopJobReco',
    utm_term: 'homepage2',
    source: 'homePage'
};
var makeRequest = function (path, method, body, langCode) {
    if (method === void 0) { method = 'get'; }
    if (body === void 0) { body = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(path, {
                        method: method,
                        body: body,
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
                case 1:
                    res = _a.sent();
                    if (res.status !== 200) {
                        throw new Error('Request error');
                    }
                    return [4 /*yield*/, res.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
var buildQueryString = function (params) {
    var queryString = [];
    for (var key in params) {
        if (params.hasOwnProperty(key) && !!params[key]) {
            queryString.push("".concat(key, "=").concat(encodeURIComponent(params[key])));
        }
    }
    return queryString.length > 0 ? queryString.join('&') : '';
};
var buildJobUrl = function (jobId, alias, languageId, queryParams, vnwBaseURL) {
    var queryString = '';
    if (queryParams) {
        queryString = buildQueryString(queryParams);
    }
    var baseJobUrl = "".concat(vnwBaseURL).concat(alias, "-").concat(jobId, "-").concat(languageId === LANG_ID_EN ? 'jd' : 'jv');
    return queryString !== '' ? "".concat(baseJobUrl, "/?").concat(queryString) : baseJobUrl;
};
var utmRecoJob = function (jobSource, utmData) {
    var utm = {
        utm_source_navi: utmData.utm_source,
        utm_medium_navi: utmData.utm_medium,
        utm_campaign_navi: utmData.utm_campaign,
        utm_content_navi: jobSource,
        utm_term_navi: utmData.utm_term,
        source: utmData.source
    };
    return buildQueryString(utm);
};
var buildUrl = function (jobId, userId, limit, apiUrl, language) {
    var queryString = buildQueryString({
        jobId: jobId,
        user: userId,
        limit: limit,
        t: String(Date.now()),
        lang: language
    });
    return "".concat(apiUrl, "?").concat(queryString);
};
var getRecommendJobs = function (jobId, userId, langCode, limit, apiUrl, vnwBaseURL, utmData) {
    if (jobId === void 0) { jobId = 0; }
    if (userId === void 0) { userId = 0; }
    if (langCode === void 0) { langCode = 1; }
    if (limit === void 0) { limit = 80; }
    if (apiUrl === void 0) { apiUrl = API_URL; }
    if (vnwBaseURL === void 0) { vnwBaseURL = VNW_BASE_URL; }
    if (utmData === void 0) { utmData = UTM; }
    return __awaiter(void 0, void 0, void 0, function () {
        var data, trackingSource, utmTracking_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeRequest(buildUrl(jobId, userId, limit, apiUrl, langCode === 1 ? ELanguage.VI : ELanguage.EN), 'get', null, langCode === 1 ? ELanguage.VI : ELanguage.EN)];
                case 1:
                    data = _a.sent();
                    if (data.jobs) {
                        trackingSource = data.source;
                        utmTracking_1 = utmRecoJob(trackingSource, utmData);
                        return [2 /*return*/, data.jobs.map(function (item) {
                                var _a;
                                return (__assign(__assign({}, item), { locationsForLanguage: (_a = item.locations) === null || _a === void 0 ? void 0 : _a[langCode === 1 ? 1 : 2], url: "".concat(buildJobUrl(item.jobId, item.alias, langCode, '', vnwBaseURL), "?").concat(utmTracking_1) }));
                            })];
                    }
                    return [2 /*return*/, []];
            }
        });
    });
};

export { getRecommendJobs };
//# sourceMappingURL=services.js.map
